import { isArray } from 'lodash';

const serializeSegment = segment => {
  if (!segment) return null;

  return {
    id: segment.id,
    shortTitle: segment.title_short,
    title: segment.title,
  };
};

export const serializeOrderSegments = segments => {
  if (!isArray(segments) && segments.length < 1) return null;

  return segments.map(segment => serializeSegment(segment));
};
